<template>
  <main id="main-content">
    <ApiLoading v-if="isApiLoading || isApiFail" :apiError="isApiFail" />
    <div class="feature-landing-page" v-else>
      <div class="content-page-banner">
        <div class="banner-content">
          <h1>{{ $route.meta.title }}</h1>
          <div class="underline"></div>
          <div>
            <div v-if="doesPolicyHaveAnActiveRebate" v-html="refData.rebateHistoryDescriptionTextActive.informationText" />
            <div v-else v-html="refData.rebateHistoryDescriptionTextInactive.informationText" />
          </div>
        </div>
      </div>

      <!-- <Alert v-if="doesPolicyHaveAnActiveRebate" alertType="info" :message="refData.rebateHistoryInformationBannerTextInactive.informationText" /> -->

      <RecordsView
        :apiStatus="{ refData: apiStatus.refData, recordData: {} }"
        :recordsData="rebateTierHistoryFormattedData"
        :referenceData="{}"
        :isExternalLink="false"
        :linkColumnValue="null"
        :includeRecordHeader="false"
        :includeRecentHeader="false"
        class="margin-top"
      >
        <template #pagination>
          <Pagination isSPA @toPageNumber="paginationNavigation" :endPage="paginationParams.lastPageNum" :currentPageFromParent="paginationParams.pageNum">
            <template #paginationLabel>
              <strong>
                {{
                  getPaginationDisplayLabel(paginationParams.pageNum, paginationParams.pageSize, rebateTierHistoryFormattedData.data.length, paginationParams.totalNum, 'events')
                }}
              </strong>
            </template>
          </Pagination>
        </template>
      </RecordsView>
    </div>
  </main>
</template>

<script>
import { RecordsView, ApiLoading } from '@/components';
import { reverseFormatFormDate } from '@general/js/utils';
import { Pagination } from '@general/js/components';
import { getPaginationDisplayLabel } from '@/utils/DisplayUtils';
import { DeviceTypes, RebateTierDisplayWithoutIncomeBrackets } from '@/enums';
import RebateServices from '@/services/MyCover/Rebates';
import { getCurrentDeviceLayout, sortByObjectProperty } from '@/utils';
import RebateMixins from './RebateMixins';

export default {
  name: 'RebateTierHistory',
  components: {
    RecordsView,
    Pagination,
    ApiLoading,
  },
  mixins: [RebateMixins],

  data() {
    return {
      apiStatus: {
        refData: {
          loading: false,
          fail: false,
        },
      },
      paginationParams: {
        pageNum: 1,
        pageSize: 10,
        totalNum: 0,
        lastPageNum: 1,
      },
      refData: {},
      windowWidth: window.innerWidth,
    };
  },

  beforeMount() {
    this.fetchRefData();
  },

  watch: {
    '$route.query.pageNum': {
      handler(newNum, oldNum) {
        if (newNum !== oldNum) {
          this.paginationNavigation(newNum);
        }
      },
      immediate: true, // so that correct page data is shown on first load when visiting directly via url and pageNum query param is present
    },
  },

  mounted() {
    this.paginationParams.totalNum = this.rebateHistory.rebateTierHistory.length;
    this.paginationParams.lastPageNum = Math.ceil(this.paginationParams.totalNum / this.paginationParams.pageSize);

    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },

  computed: {
    currentDevice() {
      return getCurrentDeviceLayout(this.windowWidth);
    },

    rebateTierHistoryFormattedData() {
      const headings = ['Rebate Tier', 'Start date', 'End date'];

      let slicedData = this.rebateHistory.rebateTierHistory.slice(
        (this.paginationParams.pageNum - 1) * this.paginationParams.pageSize,
        this.paginationParams.pageNum * this.paginationParams.pageSize,
      );

      slicedData = sortByObjectProperty(slicedData, 'startDate');

      const formattedData = slicedData.map((item) => {
        return {
          [headings[0]]: RebateTierDisplayWithoutIncomeBrackets[item.rebateTier.toUpperCase()],
          [headings[1]]: reverseFormatFormDate(item.startDate),
          [headings[2]]: reverseFormatFormDate(item.endDate),
        };
      });

      const colSetting = this.currentDevice === DeviceTypes.MOBILE ? [] : [{}, { width: '25%' }, {}];

      return {
        headings,
        data: formattedData,
        noRecordsText: 'You currently do not have any rebate tier history available',
        colSetting,
      };
    },

    isApiLoading() {
      return this.apiStatus.refData.loading;
    },

    isApiFail() {
      return this.apiStatus.refData.fail;
    },
  },

  methods: {
    paginationNavigation(pageNum) {
      this.paginationParams.pageNum = Number(pageNum);
    },

    async fetchRefData() {
      this.apiStatus.refData.loading = true;
      this.apiStatus.refData.fail = false;
      try {
        this.refData = await RebateServices.getRebateTierHistoryRefData();
      } catch (error) {
        this.apiStatus.refData.fail = true;
        logger.log('Error fetching rebate landing ref data', error);
      } finally {
        this.apiStatus.refData.loading = false;
      }
    },

    getPaginationDisplayLabel,
  },
};
</script>

<style lang="scss" scoped>
.margin-top {
  margin-top: 3.5em;
}

:deep(table tr) {
  th:first-child,
  td:first-child {
    @include tablet-and-above {
      padding-left: 52px;
    }
  }
}
</style>
